import { RefCallback, DependencyList } from "react";
// eslint-disable-next-line no-restricted-imports
import { HotkeyCallback, Keys, useHotkeys, Options } from "react-hotkeys-hook";

export interface OptionsWithRequireDescription extends Options {
    description: string;
}

export enum HOTKEYS_SCOPES {
    MAIN = "main",
    GLOBAL = "global",
    SETTINGS_MODAL = "settings-modal",
    GENERAL_MODAL = "general-modal",
}

interface UseKeyboardCommandProps {
    keys: Keys;
    callback: HotkeyCallback;
    options: OptionsWithRequireDescription;
    dependencies?: DependencyList;
}

export const useKeyboardCommand = <T extends HTMLElement>({
    keys,
    callback,
    options,
    dependencies,
}: UseKeyboardCommandProps): RefCallback<T | null> =>
    useHotkeys(
        keys,
        callback,
        { ...options, scopes: options.scopes ?? [HOTKEYS_SCOPES.MAIN] },
        dependencies,
    );
